import script from "./CreateReportDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateReportDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CreateReportDialog.vue?vue&type=style&index=0&id=5237857f&lang=sass"

const __exports__ = script;

export default __exports__